import { AdditionalInterestAndInsured } from 'src/configs/APISchemas/Application.schema';
import { PaymentPlanEnum } from 'src/configs/APISchemas/BindPolicy';
import { PaymentFormValues } from 'src/pages/payment-msi/PaymentMsiV2/PaymentMsiV2';
import { BillingAddress } from 'src/pages/payment-msi/PaymentMsiV2/types/billing-address.type';
import { InterestedParty } from 'src/pages/payment-msi/PaymentMsiV2/types/interested-party.type';

interface GetPaymentFormDefaultValuesArgs {
  interestedParty: InterestedParty | null;
  additionalInterests: AdditionalInterestAndInsured[] | null;
  additionalInsured: AdditionalInterestAndInsured[] | null;
  paymentPlan: PaymentPlanEnum | null;
  buildingAddress: BillingAddress | null;
  agreed: boolean | null;
}

export const getPaymentFormDefaultValues = ({
  additionalInsured,
  agreed,
  additionalInterests,
  buildingAddress,
  interestedParty,
  paymentPlan,
}: GetPaymentFormDefaultValuesArgs): PaymentFormValues => {
  const defaultInterestedParty = getDefaultInterestedParty({
    additionalInterests: additionalInterests,
    interestedParty,
  });

  return {
    additionalInsured:
      additionalInsured && additionalInsured.length > 0
        ? additionalInsured
        : [
            {
              email: '',
              firstName: '',
              lastName: '',
            },
          ],
    agreed: agreed ?? false,
    billingAddress: buildingAddress ?? {
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      zipCode: '',
    },
    interestedParty: defaultInterestedParty,
    paymentData: null,
    paymentPlan: paymentPlan ?? PaymentPlanEnum.Annual,
  };
};

interface GetInterestedPartyArgs {
  interestedParty: InterestedParty | null;
  additionalInterests: AdditionalInterestAndInsured[] | null;
}
function getDefaultInterestedParty({
  additionalInterests,
  interestedParty,
}: GetInterestedPartyArgs): InterestedParty {
  if (interestedParty) {
    return interestedParty;
  }

  if (!additionalInterests || additionalInterests.length === 0) {
    return {
      email: '',
      fullName: '',
    };
  }

  const firstAdditionalInterest = additionalInterests[0];
  const additionalInterestFirstName = firstAdditionalInterest.firstName ?? '';
  const additionalInterestLastName = firstAdditionalInterest.lastName ? firstAdditionalInterest.lastName.replace(/^\./, '') : '';

  return {
    email: firstAdditionalInterest.email,
    fullName:
      `${additionalInterestFirstName} ${additionalInterestLastName}`.trim(),
  };
}
